import(/* webpackMode: "eager" */ "/vercel/path1/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsProvider"] */ "/vercel/path1/components/analytics-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path1/components/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackButton"] */ "/vercel/path1/components/feedback/feedback-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path1/components/posthog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path1/lib/theme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path1/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path1/node_modules/@vercel/speed-insights/dist/next/index.mjs");
